
ColumnasUsuariosDirective.$inject = [];

export default function ColumnasUsuariosDirective() {
    return {
        restrict: 'E',
        scope: {
            'tabs': '=',
            'tipo': '=',
        },
        template: require('./columnas-usuarios.html'),
        controller: 'ColumnasUsuariosCtrl as vm'
    }
}